import { render } from "./GalleryEntryLink.vue?vue&type=template&id=5971eacb"
import script from "./GalleryEntryLink.vue?vue&type=script&lang=js"
export * from "./GalleryEntryLink.vue?vue&type=script&lang=js"

import "./GalleryEntryLink.vue?vue&type=style&index=0&id=5971eacb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__